import { useRef, useEffect } from 'react';
import OLTileLayer from 'ol/layer/Tile';
import TileGrid from 'ol/tilegrid/TileGrid';
import { createXYZ } from 'ol/tilegrid';
import { xyzSourceFactory } from '../../utils/xyzSourceFactory';
import { useOLMap } from '../MapContext';
import { useLayerEffect } from './useLayerEffect';
export const TileLayer = (props) => {
    const map = useOLMap();
    const layerRef = useRef();
    useLayerEffect(layerRef, props.layerOptions);
    useEffect(() => {
        const projection = map.getView().getProjection();
        let tileGrid = undefined;
        if (props.gridParams && props.gridParams.resolutions && props.gridParams.origin) {
            tileGrid = new TileGrid({
                origin: props.gridParams.origin,
                resolutions: props.gridParams.resolutions,
                tileSize: props.gridParams.tileSize,
            });
        }
        else if (props.gridParams && props.gridParams.extent) {
            tileGrid = createXYZ({
                extent: props.gridParams.extent,
                tileSize: props.gridParams.tileSize,
            });
        }
        const layer = new OLTileLayer({
            source: xyzSourceFactory({
                ...props.sourceOptions,
                projection,
                wrapX: projection.isGlobal(),
                tileGrid,
            }),
            visible: props.layerOptions.visible,
            opacity: props.layerOptions.opacity ?? 1,
            minResolution: props.layerOptions.minResolution,
            maxResolution: props.layerOptions.maxResolution,
            zIndex: props.layerOptions.zIndex,
        });
        layerRef.current = layer;
        map.addLayer(layer);
        if (process.env.NODE_ENV === 'development') {
            console.debug('new TileLayer', map, layerRef.current);
        }
        return () => {
            // unmount
            const layer = layerRef.current;
            if (layer) {
                map.removeLayer(layer);
                layer.dispose();
                layerRef.current = null;
            }
        };
    }, [map, props.sourceOptions]);
    return null;
};
//# sourceMappingURL=TileLayer.js.map